<template>
  <div>
    <Header />
    <div class="container">
      <br />
      <el-row>
        <el-col :sm="24">
          <h2>{{ $t("Verifíque si su contrato existe") }}</h2>
        </el-col>
        <el-col :sm="24">
          <el-form :inline="true" :model="busqueda" label-position="top">
            <el-form-item label="Búsqueda avanzada">
              <el-input
                placeholder="Nombre, número de contrato ..."
                style="width: 300px"
                size="small"
                v-model="busqueda.search"
              ></el-input>
            </el-form-item>
            <el-form-item label="Seleccione Faena">
              <el-select style="width: 300px" v-model="faena_id" size="small">
                <el-option
                  v-for="faena in faenas"
                  v-if="
                    faena._id === '5a6f78337b772dcfe68241d5' ||
                    faena._id === '5a6f78417b772dcfe68241e5' ||
                    faena._id === '5a6f784e7b772dcfe68241f4' ||
                    faena._id === '5b48f15d6f0ed90fc02826e3'
                  "
                  :key="faena._id"
                  :label="faena.nombre"
                  :value="faena._id"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <br />
              <el-button
                icon="el-icon-search"
                size="small"
                type="info"
                @click="onSubmit"
                >Buscar</el-button
              >
            </el-form-item>
            <el-form-item label="¿Tu contrato no se encuentra creado?">
              <el-button
                style="width: 100%"
                icon="el-icon-plus"
                size="small"
                type="primary"
                @click="createContract"
                >Crear nuevo contrato</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :sm="24">
          <br />
          <center v-if="loading">
            <br />
            <br />
            <Circle9 style="margin-bottom: 8px"></Circle9>
            <small>Cargando Datos ...</small>
            <br />
            <br />
          </center>
          <el-table
            v-else
            row-class-name="rowClassTablaPloma"
            cell-class-name="cellClassTablaPloma"
            header-cell-class-name="header-cell-class-table-gray"
            :data="paginar === false ? data : paginarContratos()"
            style="width: 100%"
          >
            <el-table-column prop="nombre" label="Nombre"> </el-table-column>
            <el-table-column width="200" prop="tipo_contrato" label="Tipo">
            </el-table-column>
            <el-table-column prop="area" label="Área"> </el-table-column>
            <el-table-column width="260" label="Número de contrato">
              <template slot-scope="scope">
                <el-tag
                  v-if="!scope.row.numero_contrato"
                  size="small"
                  type="warning"
                  >Sin número de contrato</el-tag
                >
                <span v-else>{{ scope.row.numero_contrato }}</span>
              </template>
            </el-table-column>
            <el-table-column width="260" label="Fecha inicio">
              <template slot-scope="scope">
                {{ scope.row.fecha_inicio | moment("LL") }}
              </template>
            </el-table-column>
            <el-table-column width="260" label="Fecha fin">
              <template slot-scope="scope">
                {{ scope.row.fecha_fin | moment("LL") }}
              </template>
            </el-table-column>
          </el-table>
          <br />
          <br />
          <center>
            <el-pagination
              :current-page="page"
              @prev-click="backPage"
              @next-click="nextPage"
              @current-change="currentPage"
              :page-size="6"
              layout="prev, pager, next"
              :total="totalPage"
            ></el-pagination>
            <br />
            <el-button
              type="primary"
              @click="backStep()"
              icon="el-icon-arrow-left"
              >Regresar</el-button
            >
          </center>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { Circle9 } from "vue-loading-spinner";
import Header from "../components/Header.vue";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "wizard",
  components: {
    Header,
    Circle9,
  },
  data() {
    return {
      paginar: false,
      loading: false,
      faenas: [],
      faena_id: "",
      data: [],
      busqueda: {
        search: "",
      },
      page: 1,
      totalPage: 0,
      resetSearch: false,
    };
  },
  watch: {
    "busqueda.search": function (oldVal, newVal) {
      this.resetSearch = true;
    },
    faena_id: function (oldVal, newVal) {
      this.resetSearch = true;
    },
  },
  async created() {
    await this.getFaenas();
  },
  methods: {
    backStep() {
      window.history.go(-1);
    },
    createContract() {
      this.$router.push({ name: "autoCreacionStep1" });
    },
    async currentPage(page) {
      this.page = page;
      this.onSubmit(page, this.search);
    },
    async nextPage(page) {
      this.page = page;
      this.onSubmit(page, this.search);
    },
    async backPage(page) {
      this.page = page;
      this.onSubmit(page, this.search);
    },
    paginarContratos() {
      return this.data.slice((this.page - 1) * 6, this.page * 6);
    },
    async onSubmit() {
      try {
        let busqueda = "";
        if (this.busqueda.search === "") {
          busqueda = "null";
        } else {
          busqueda = this.busqueda.search;
        }
        this.loading = true;
        if (this.resetSearch === true) {
          this.page = 1;
        }
        let response = await axios.get(
          `/data-science/getAllContracts/${this.faena_id}/${this.page}/${busqueda}`
        );
        this.resetSearch = false;
        this.data = response.data.results;
        this.totalPage = response.data.total;
        this.paginar = response.data.paginar;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async getFaenas() {
      let response = await axios.get(`/data-science/faenas`);
      this.faenas = response.data;
    },
  },
};
</script>

<style scoped>
</style>
